import { render } from "./TheResults.vue?vue&type=template&id=8db55956&scoped=true"
import script from "./TheResults.vue?vue&type=script&lang=js"
export * from "./TheResults.vue?vue&type=script&lang=js"

import "./TheResults.vue?vue&type=style&index=0&id=8db55956&scoped=true&lang=css"

import exportComponent from "/Users/curtismensah/Projects/Litt/Brit/brit-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8db55956"]])

export default __exports__